import { useMediaQuery } from '@/hooks/useMediaQuery';
import { useEffect } from 'react';
import { create } from 'zustand';

export type SideMenuContent =
  | 'initial'
  | 'offers'
  | 'villas-in-sicily'
  | 'villas-in-puglia'
  | 'experiences'
  | 'guides';

type State = {
  isOpen: boolean;
  toggle: () => void;
  close: () => void;
  currentContent: SideMenuContent;
  setCurrentContent: (content: SideMenuContent) => void;
};

const useStore = create<State>()((set, get) => ({
  isOpen: false,
  toggle: () =>
    set((state) => ({
      isOpen: !state.isOpen,
      currentContent: get().isOpen ? get().currentContent : 'initial',
    })),
  close: () => set({ isOpen: false }),
  currentContent: 'initial',
  setCurrentContent: (content: SideMenuContent) =>
    set({ currentContent: content }),
}));

export const useSideMenu = () => {
  const isDesktop = useMediaQuery('(min-width: 1024px)');
  const { isOpen, toggle, close, currentContent, setCurrentContent } =
    useStore();

  useEffect(() => {
    if (isDesktop) {
      close();
    }
  }, [isDesktop, close]);

  return {
    isOpen,
    toggle,
    close,
    currentContent,
    setCurrentContent,
  };
};
